var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"src",style:('background-image:Url('+require(("@/assets/BackgroundImages/" + _vm.backgroundSrc))+')'),attrs:{"id":"background-component"}})}
var staticRenderFns = []

export { render, staticRenderFns }